import { Howl } from "howler";

import { GameData } from "../../gamestate/gameData";
import { getWinContext } from "../../inGameFunction";
import { sergioWild } from "./santaWild";
import DeviceChecker from "../../../../common/functions/helper.ts/DeviceChecker";
export class santaManager {
  private parent: PIXI.Container;
  private SantaList: Array<sergioWild>;
  private maskSanta: PIXI.Graphics;
  // private santaLocations: Array<number>;
  private santaJumpVoice: Howl;
  private santaJumpLand: Howl;
  private activeGameData: GameData;
  private hohoList: Array<string>;
  private santaLocationsServer: Array<boolean>;
  private previousSantaLocationsLocal: Array<boolean>;
  // private santaPerColumn: Array<number>;
  constructor(parent: PIXI.Container, activeGameData: GameData) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.activeGameData = activeGameData;
    this.SantaList = [];
    this.previousSantaLocationsLocal = [false, false, false, false, false];
    // this.santaPerColumn = [0, 0, 0, 0, 0];
    this.santaLocationsServer = [false, false, false, false, false]; //allows to compare woth server result and stored local
    // this.santaLocations = [];
    for (let i = 0; i < 6; i++) {
      this.SantaList[i] = new sergioWild(this.parent, activeGameData, i);
      this.SantaList[i].setCurrentColumn(0);
      // this.santaLocations[i] = 0; //invisible
    }

    this.maskSanta = new PIXI.Graphics();
    this.maskSanta.beginFill(0xff0000);
    this.maskSanta.drawRect(0, 0, 270 * 5, 825);
    this.maskSanta.alpha = 0.2;
    this.maskSanta.x = 1920 / 2 - this.maskSanta.width / 2;
    this.maskSanta.y = 115;
    this.maskSanta.endFill();
    this.parent.addChild(this.maskSanta);
    this.parent.mask = this.maskSanta;

    this.santaJumpLand = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/jumpandland.m4a?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 0.25,
      // html5:true,
      sprite: {
        land: [400, 1000, false],
      },
    });

    this.santaJumpVoice = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/SergioVoice.mp3?" +
          "version=" +
          this.activeGameData.gameVersion,
      ],
      volume: 1,

      sprite: {
        ohyeah: [9256, 10574 - 9056, false],
        ohyeah1: [8860, 10374 - 8860, false],
        ohyeah2: [8860, 10374 - 8860, false],
        jackpot: [23293, 25752 - 23293, false],
      },
    });
    // this.santaJumpVoice.play("hoho5")
    this.hohoList = ["ohyeah", "ohyeah", "ohyeah"];

    this.activeGameData.soundList.push(this.santaJumpLand);
    this.activeGameData.soundList.push(this.santaJumpVoice);
  }

  public getIsergioExpanding = (): boolean => {
    let bool = false;
    for (let i = 0; i < this.SantaList.length; i++) {
      if (this.SantaList[i].getIsAnimationActive()) {
        bool = true;
        break;
      }
    }
    return bool;
  };
  public playJackpotVoice = (): void => {
    // console.log("PLAy SOUND")
    this.santaJumpVoice.stop();
    this.santaJumpVoice.play("jackpot");
  };
  public reload = (newLocations: Array<number>): void => {
    let checkCol = [];
    for (let i = 0; i < this.SantaList.length; i++) {
      this.SantaList[i].clear();
      // this.santaLocations = [];
      checkCol.push(this.SantaList[i].getCurrentColumn());
    }
    // console.log("CLEARED COL", checkCol);
    for (let i = 0; i < newLocations.length; i++) {
      this.SantaList[i].setSantaLocation(newLocations[i]);
    }
  };
  private CompareWithServer = (
    newServerData: Array<boolean>
  ): Array<number> => {
    let positionForMewSanta = [];
    for (let i = 0; i < this.santaLocationsServer.length; i++) {
      if (this.santaLocationsServer[i] != newServerData[i]) {
        //is diffrent
        if (newServerData[i] == true) {
          //and has new santa
          positionForMewSanta.push(i);
        }
      }
    }
    // console.log(newServerData,positionForMewSanta)
    return positionForMewSanta;
  };
  public expandAndUpdateSantaOnReel = (): void => {
    // console.log("contextNUM",this.activeGameData.betResponse.gameContext.contextNumber);
    if (this.activeGameData.santaExpandable) {
      //--expand santa
      let activeResult = getWinContext(this.activeGameData);
      let expandedWildReels = activeResult.expandedWildReels;

      //compare the data with the server and  add new Santa
      let santaLocationsX = this.CompareWithServer(expandedWildReels);
      //-once comparaison complete , new context replace old

      this.santaLocationsServer = expandedWildReels;

      let santaLocationsY: Array<number> = [];
      // console.log(expandedWildReels)
      // console.log("PLACE SANTA TO REEL ",santaLocationsX)

      for (let i = 0; i < santaLocationsX.length; i++) {
        let colValues = activeResult.reels[santaLocationsX[i]];
        if (colValues[0] == 9) {
          santaLocationsY[i] = 0;
        } else if (colValues[1] == 9) {
          santaLocationsY[i] = 1;
        } else if (colValues[2] == 9) {
          santaLocationsY[i] = 2;
        }
      }

      // console.log("contextNUM",santaLocationsX);

      for (let i = 0; i < santaLocationsX.length; i++) {
        this.addNewSanta(santaLocationsX[i] + 1, santaLocationsY[i] + 1);
        this.activeGameData.mainGame.setColumnVisibilty(
          santaLocationsX[i],
          false
        );
      }
    }
    this.activeGameData.mainGame.setGameStop(this.activeGameData.GameContext());
    this.activeGameData.mainGame.SetRoundEnd();
  };

  public clearAll = (): void => {
    //-
    // this.parent.alpha=(1)
    this.activeGameData.mainGame.restoreColumnVisiblity();
    // this.previousSantaLocationsLocal=[false,false,false,false,false];
    this.santaLocationsServer = [false, false, false, false, false];
    // this.santaLocations=[];
    for (let i = 0; i < this.SantaList.length; i++) {
      this.SantaList[i].clear();
    }
  };

  public clearHistory = (): void => {
    this.previousSantaLocationsLocal = [false, false, false, false, false];
  };

  public isWildGameActive = (): boolean => {
    for (
      let index = 0;
      index < this.previousSantaLocationsLocal.length;
      index++
    ) {
      if (this.previousSantaLocationsLocal[index] == true) {
        // console.log( this.santaLocationsServer,true)
        return true;
      }
    }
    // console.log( this.santaLocationsServer,false)
    return false;
  };
  public isWildVisible = (): boolean => {
    for (let index = 0; index < this.santaLocationsServer.length; index++) {
      if (this.santaLocationsServer[index] == true) {
        // console.log( this.santaLocationsServer,true)
        return true;
      }
    }
    // console.log( this.santaLocationsServer,false)
    return false;
  };
  public reloadSanta = (): void => {
    let winContext = getWinContext(this.activeGameData);
    if (this.santaLocationsServer != winContext.expandedWildReels) {
      //
      // console.log("SANTA MISSING");
      // this.santaLocationsServer=winContext.expandedWildReels;
      this.activeGameData.santaExpandable = true;
      // this.expandAndUpdateSantaOnReel();
      this.quickReloadSanta();
    } else {
      this.activeGameData.santaExpandable = false;
    }
  };

  private quickReloadSanta = (): void => {
    if (this.activeGameData.santaExpandable) {
      //--expand santa
      let activeResult = getWinContext(this.activeGameData);
      let expandedWildReels = activeResult.expandedWildReels;

      //compare the data with the server and  add new Santa
      let santaLocationsX = this.CompareWithServer(expandedWildReels);
      //-once comparaison complete , new context replace old

      this.santaLocationsServer = expandedWildReels;

      let santaLocationsY: Array<number> = [];
      // console.log(expandedWildReels)
      // console.log("PLACE SANTA TO REEL ",santaLocationsX)

      for (let i = 0; i < santaLocationsX.length; i++) {
        let colValues = activeResult.reels[santaLocationsX[i]];

        if (colValues[0] == 9) {
          santaLocationsY[i] = 0;
        } else if (colValues[1] == 9) {
          santaLocationsY[i] = 1;
        } else if (colValues[2] == 9) {
          santaLocationsY[i] = 2;
        }
      }

      for (let i = 0; i < santaLocationsX.length; i++) {
        this.addNewSantaNonAnimated(
          santaLocationsX[i] + 1,
          santaLocationsY[i] + 1
        );

        // console.log('reloadSanta at',santaLocationsX[i] + 1, santaLocationsY[i] + 1)

        this.activeGameData.mainGame.setColumnVisibilty(
          santaLocationsX[i],
          false
        );
      }
    }
  };

  public moveToNewReel = (): void => {
    //-clear all the previous santa
    this.previousSantaLocationsLocal = this.santaLocationsServer;
    // console.log("NEW", this.previousSantaLocationsLocal)
    this.clearAll();

    let activeResult = getWinContext(this.activeGameData);
    // console.log(this.activeGameData.GameContext());
    let expandedWildReels = activeResult.expandedWildReels;

    this.santaLocationsServer = expandedWildReels; //<--santa moved to new location

    // console.log( ">>>",this.santaLocationsServer)
    //-add santa to proper index+1 and jump

    for (let i = 0; i < 5; i++) {
      if (this.santaLocationsServer[i]) {
        this.activeGameData.mainGame.setColumnVisibilty(i, false);
        // this.SantaList[i].setSantaLocation(i+1);//-

        this.SantaList[i].setSantaLocation(i + 2); //-

        this.SantaList[i].startJump();
      }
    }
    this.previousSantaLocationsLocal;

    // previousPosition
    if (this.previousSantaLocationsLocal[0] == true) {
      // //-if santa exist on first colum
      // if(this.previousSantaLocationsLocal[1]==true)
      // {
      //   this.activeGameData.mainGame.setColumnVisibilty(0,false);
      // }
      // else
      // {
      //   this.activeGameData.mainGame.setColumnVisibilty(0,true);
      // }

      this.SantaList[5].setSantaLocation(0 + 1); //-
      this.SantaList[5].startJump();
    }

    this.activeGameData.NewWinSound.stop();
    this.activeGameData.NewWinSound.play("reelSpinSatnaBell");

    this.santaJumpLand.play("land");
    this.activeGameData.NewWinSound.play("santaBellWind");

    // return// skip

    // for (let i = 0; i < this.SantaList.length; i++) {
    //   //   this.SantaList[i].startJump();
    //   this.SantaList[i].startJump();
    //   // console.log("Get POSITION OF SANTA", this.SantaList[i].getCurrentColumn() )
    //   if (this.SantaList[i].getCurrentColumn() > 0) {
    //     this.santaLocations[this.SantaList[i].getCurrentColumn()] = 1;
    //   } else {
    //     this.santaLocations[this.SantaList[i].getCurrentColumn()] = 0;
    //   }
    // }

    // for (let i = 0; i < this.SantaList.length; i++) {
    //   this.SantaList[i].hideSantaAndResetColumn();
    // }

    // //reassign santa animation ready to taht position
    // let playLandSound = false;
    // for (let i = 0; i < this.SantaList.length; i++) {
    //   if (this.santaLocations[i] == 1) {
    //     if (playLandSound == false) {
    //       playLandSound = true;
    //     }
    //     this.SantaList[i].setSantaLocation(i);
    //     // console.log(i,"placeSantaHere")
    //     let currColumn = this.SantaList[i].getCurrentColumn();
    //     if (currColumn > 0 === true) {
    //       this.SantaList[i].setCurrentColumn(currColumn - 1);
    //     }
    //   }
    // }
    // if (playLandSound) {
    //   this.santaJumpLand.play("land");
    //   this.activeGameData.NewWinSound.play("santaBellWind");
    // }
    // this.santaLocations.shift(); //--move all santa to left
    // this.santaLocations[5] = 0; //- last one remains empty after moving
  };
  public addNewSanta = (posX: number, posY: number): void => {
    let unsuedSantaIndex = this.getNoneUsedSantaIndex();
    this.santaJumpVoice.stop();
    let randomIndex = Math.floor(Math.random() * this.hohoList.length);
    this.activeGameData.NewWinSound.play("santaBellWindAppear");
    this.santaJumpVoice.play(this.hohoList[randomIndex]); //play random ho ho ho

    this.SantaList[unsuedSantaIndex].addNewSantaAt(posX, posY); //make santa enter the gameFied
  };
  private addNewSantaNonAnimated = (posX: number, posY: number): void => {
    let unsuedSantaIndex = this.getNoneUsedSantaIndex();
    this.santaJumpVoice.stop();
    // let randomIndex = Math.floor(Math.random() * this.hohoList.length);
    // this.activeGameData.NewWinSound.play("santaBellWindAppear");
    // this.santaJumpVoice.play(this.hohoList[randomIndex]); //play random ho ho ho

    this.SantaList[unsuedSantaIndex].reloadSantaAt(posX, posY); //make santa enter the gameFied
  };

  private getNoneUsedSantaIndex = (): number => {
    for (let i = 0; i < this.SantaList.length; i++) {
      if (this.SantaList[i].getCurrentColumn() <= 0) {
        return i;
      }
    }
  };

  // private teleportSantaToColumn(column:number)
  // {
  //     this.SantaList[0].setSantaLocation(column);
  // }
}
